import React, { useCallback, useMemo } from 'react';

import { FiX } from 'react-icons/fi';
import { unshareBoard } from '../../../services/api/api';
import { useCurrentBoard, useCurrentUser } from '../../../services/state';
import { LoadingSpinner } from '../../common/loading-spinner/LoadingSpinner';

import '../../../style/Common.css';

const UsersWithAccess = ({ permissions, setPermissions, loading }) => {
  const { email: userEmail } = useCurrentUser();
  const { id: boardId } = useCurrentBoard();

  const usersWithAccess = useMemo(
    () =>
      Object.keys(permissions)
        .flatMap(role => permissions[role].map(user => ({ ...user, role })))
        .filter(user => user.email !== userEmail),
    [userEmail, permissions]
  );

  const removeUser = useCallback(
    async user => {
      const newPermissions = await unshareBoard({
        boardId,
        role: user.role,
        userIds: [user.id]
      });
      setPermissions(newPermissions);
    },
    [boardId, setPermissions]
  );

  return (
    <div className="AddedEmailsSectionWrapper">
      <h3 className="m-b-1">People with access</h3>
      {loading ? <LoadingSpinner /> : <UserList users={usersWithAccess} removeUser={removeUser} />}
    </div>
  );
};

const UserList = ({ removeUser, users }) => {
  return users.length === 0 ? (
    <div className="m-b-1">This board has not been shared yet</div>
  ) : (
    <div className="AddedEmailsSection">
      {users.map(user => (
        <div key={`${user.role}_${user.id}`} className="addedEmailBlock">
          <div className="added-user-email">{user.email}</div>
          <div className="role">{user.role}</div>
          <div className="remove-icon" onClick={() => removeUser(user)}>
            <FiX size={'0.8rem'} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default UsersWithAccess;
